/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { BackButton } from "UpduoLibrary";
import { skalePrimaryBlue } from "config/UpduoColors";
import ConfirmationView from "./StartViews/ConfirmationView";
import SignupLoginView from "./StartViews/SignupLoginView";
interface ConfirmationPaneProps {
  onBack: Function;
  onLoginPress: Function;
  loginValidationText: string;
  isLoginInProgress: boolean;
  onConfirmationPress: Function;
}

export default function ConfirmationPane({
  onBack,
  onLoginPress,
  loginValidationText,
  isLoginInProgress,
  onConfirmationPress,
}: ConfirmationPaneProps) {
  const startObject = useSelector((state: RootState) => state.startObject);

  return (
    <View
      style={{
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {startObject.userExists ? (
        <SignupLoginView
          onLoginPress={onLoginPress}
          loginValidationText={loginValidationText}
          isLoginInProgress={isLoginInProgress}
        />
      ) : (
        <ConfirmationView onBack={onBack} onPress={onConfirmationPress} />
      )}
      <View style={{ position: "absolute", top: 50, left: 50 }}>
        <BackButton
          color={skalePrimaryBlue}
          onPress={() => {
            onBack("confirmation");
          }}
        />
      </View>
    </View>
  );
}
